import React from 'react';

type StatusType = 'pending' | 'approved' | 'rejected' | 'flagged' | 'published' | 'draft' | 'active' | 'suspended' | 'contributor' | 'admin' | 'user';

interface StatusBadgeProps {
  status: StatusType;
  size?: 'sm' | 'md';
}

const statusConfig: Record<StatusType, { label: string; className: string }> = {
  pending: { label: 'Pending', className: 'status-pending' },
  approved: { label: 'Approved', className: 'status-approved' },
  rejected: { label: 'Rejected', className: 'status-rejected' },
  flagged: { label: 'Flagged', className: 'status-flagged' },
  published: { label: 'Published', className: 'status-approved' },
  draft: { label: 'Draft', className: 'status-pending' },
  active: { label: 'Active', className: 'status-approved' },
  suspended: { label: 'Suspended', className: 'status-rejected' },
  contributor: { label: 'Contributor', className: 'bg-purple-500/15 text-purple-400 border border-purple-500/25' },
  admin: { label: 'Admin', className: 'bg-primary/15 text-primary border border-primary/25' },
  user: { label: 'User', className: 'bg-muted text-muted-foreground border border-border' },
};

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <span
      className={`inline-flex items-center rounded-full font-500 ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      } ${config.className}`}
    >
      {config.label}
    </span>
  );
}